import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {DatePipe} from '@angular/common';
import {DateFormats} from '../../../providers/app-date-adapter';
import {TotalStatsImport} from '../../../dto/total-stats-import';
import {TotalStatsImportService} from '../../services/total-stats-import.service';

@Component({
  selector: 'app-import-transactions',
  templateUrl: './import-total-transactions.component.html',
  styleUrls: ['./import-total-transactions.component.css']
})
export class ImportTotalTransactionsComponent implements OnInit {
  public isLoading: boolean;

  dataSource = new MultiCrudDataSource(this.totalStatsImportService);

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;


  columns = [
    { columnDef: 'id',              header: 'id',      cell: (row: TotalStatsImport) => `${row.id}`},
    { columnDef: 'date',            header: 'Date',    cell: (row: TotalStatsImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime )}`},
    { columnDef: 'userId',          header: 'User',    cell: (row: TotalStatsImport) => `${row.username}`},
    { columnDef: 'ipAddress',       header: 'Ip address',   cell: (row: TotalStatsImport) => `${row.ipAddress}`},
    { columnDef: 'totalRowCount',   header: 'Total rows',   cell: (row: TotalStatsImport) => `${row.totalRowCount}`},
    { columnDef: 'invalidRowCount', header: 'Invalid rows', cell: (row: TotalStatsImport) => `${row.invalidRowCount}`},
  ];
  getRowClass = (item: any): string => item.importErrorsText ? 'warning-row' : '';

  constructor(
    private totalStatsImportService: TotalStatsImportService,
    public snackBar: MatSnackBar,

    private datePipe: DatePipe,

  ) { }

  ngOnInit() {
  }

  onUpload(file) {
    this.isLoading = true;
    this.totalStatsImportService.upload(file)
      .subscribe(
        () => {
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
          this.snackBar.open( err.error.message || err.message || err.error || err, null, {
            duration: 5000,
            panelClass: [ 'app-mat-snack-bar' ]
          });
        }

      );

  }

  deleteEnabled = () => true;

  multiselectEnabled = () => false;

  getViewLink = (item: TotalStatsImport): string => item.id.toString();

}
